/**
 * Debug-mode browser-side WebRTC stats for one camera: one line under its video tile.
 * Shared by the cloud's Cameras page and the local node's, so the two show the same thing.
 * Both apps' stats collectors produce these field names.
 */
export interface CameraDebugStatsValues {
  framesPerSecond?: number | null;
  bitrateKbps?: number | null;
  rtt?: number | null;
  jitter?: number | null;
  packetLossRate?: number | null;
  frameWidth?: number | null;
  frameHeight?: number | null;
  totalFramesDropped?: number | null;
  totalPacketsReceived?: number | null;
}

export default function CameraDebugStats({ stats }: { stats: CameraDebugStatsValues | null }) {
  if (!stats) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-2.5 gap-y-0.5 px-3 py-1 text-[10px] font-mono text-muted-foreground border-t border-border/50 bg-muted/30">
      <span title="Frames per second"><span className="text-emerald-500">FPS</span> {stats.framesPerSecond != null ? Math.round(stats.framesPerSecond) : '—'}</span>
      <span title="Bitrate (kbps)"><span className="text-blue-400">BR</span> {stats.bitrateKbps != null ? stats.bitrateKbps : '—'}</span>
      <span title="Round-trip time (ms)"><span className="text-amber-400">RTT</span> {stats.rtt != null ? stats.rtt : '—'}ms</span>
      <span title="Jitter (ms)"><span className="text-purple-400">JTR</span> {stats.jitter != null ? stats.jitter : '—'}ms</span>
      <span title="Packet loss %"><span className="text-red-400">PL</span> {stats.packetLossRate != null ? (stats.packetLossRate * 100).toFixed(1) : '—'}%</span>
      <span title="Resolution"><span className="text-cyan-400">RES</span> {stats.frameWidth && stats.frameHeight ? `${stats.frameWidth}×${stats.frameHeight}` : '—'}</span>
      <span title="Frames dropped"><span className="text-orange-400">DRP</span> {stats.totalFramesDropped ?? '—'}</span>
      <span title="Packets received"><span className="text-teal-400">PKT</span> {stats.totalPacketsReceived != null ? stats.totalPacketsReceived.toLocaleString() : '—'}</span>
    </div>
  );
}
